import { render, staticRenderFns } from "./SetupBrandPickerModal.vue?vue&type=template&id=18ba37b9"
import script from "./SetupBrandPickerModal.vue?vue&type=script&lang=js"
export * from "./SetupBrandPickerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports